/* Salveri - eigen gedrag bovenop Motion. Ingeladen in layout/theme.liquid. */
(function () {
  'use strict';

  /* -------------------------------------------------------------------------
     Productpagina: de Description-tab staat standaard open, de rest dicht.

     Motion heeft daar geen instelling voor; alle collapsibles beginnen dicht.
     We klikken daarom de trigger aan via het thema zelf, zodat de animatie, de
     hoogteberekening en de aria-status kloppen.

     Let op de volgorde: theme.js bindt zijn klikafhandeling later dan dit
     script. Een klik daarvóór doet niets. Daarom controleren we of de tab
     werkelijk open is en proberen we het anders opnieuw, in plaats van aan te
     nemen dat de klik is aangekomen.
     ------------------------------------------------------------------------- */
  var SELECTOR = '.product-single__meta .collapsible-trigger[aria-controls*="description"]';

  function tryOpen() {
    var trigger = document.querySelector(SELECTOR);
    if (!trigger) return false;
    if (trigger.getAttribute('aria-expanded') === 'true') return true;
    trigger.click();
    return trigger.getAttribute('aria-expanded') === 'true';
  }

  function init() {
    // Twee losse taken. De collectiebeschrijving mag niet afhangen van de
    // vroege `return` van de productpagina hieronder, want dan draait hij daar nooit.
    vouwBeschrijving();
    houdGevouwen();
    openDescriptionTab();
  }

  function openDescriptionTab() {
    if (!document.querySelector('.product-single__meta')) return;
    if (tryOpen()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (tryOpen() || ++tries > 40) clearInterval(timer);
    }, 100);
  }

  /* -------------------------------------------------------------------------
     Collectiepagina: van de beschrijving blijft alleen de eerste zin staan, de
     rest komt achter een "Read more".

     Besluit eigenaar 18 september 2026: de volledige tekst onder het raster oogde
     rommelig. Weglaten kostte te veel: het is de enige tekst die Google op een
     collectiepagina heeft, en hij voedt ook "description" in de CollectionPage
     structured data van main-collection.liquid.

     De volledige tekst blijft daarom in de HTML staan en wordt alleen visueel
     ingeklapt. Geen cloaking: de bezoeker kan alles openklappen en Google leest
     dezelfde tekst als de bezoeker. Zonder JavaScript staat alles gewoon open.
     ------------------------------------------------------------------------- */
  function knipEersteZin(tekst) {
    // Eerste zinseinde dat gevolgd wordt door een spatie en een hoofdletter.
    var m = tekst.match(/^[\s\S]*?[.!?](?=\s+[A-Z])/);
    return m ? m[0] : null;
  }

  var vouwTeller = 0;

  function vouwBeschrijving() {
    // Alle voorkomens, niet alleen de eerste: een thema kan er meer dan een neerzetten.
    var wraps = document.querySelectorAll('.collection-description .enlarge-text');
    Array.prototype.forEach.call(wraps, vouwEen);
  }

  function vouwEen(wrap) {
    if (!wrap || wrap.dataset.salveriGevouwen === '1') return;

    var eerste = wrap.querySelector('p');
    if (!eerste) return;

    var rest = [];
    var k = eerste.nextElementSibling;
    while (k) { rest.push(k); k = k.nextElementSibling; }

    var zin = knipEersteZin(eerste.textContent.trim());
    if (!zin && !rest.length) return;

    var staart = document.createElement('div');
    staart.className = 'salveri-meer';
    staart.id = 'salveri-collectie-meer-' + (++vouwTeller);
    staart.hidden = true;

    if (zin && zin.length < eerste.textContent.trim().length) {
      var restZin = eerste.textContent.trim().slice(zin.length).trim();
      eerste.textContent = zin;
      var p = document.createElement('p');
      p.textContent = restZin;
      staart.appendChild(p);
    }
    rest.forEach(function (el) { staart.appendChild(el); });
    wrap.appendChild(staart);

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'salveri-meer-knop';
    knop.setAttribute('aria-expanded', 'false');
    knop.setAttribute('aria-controls', staart.id);
    knop.textContent = 'Read more';
    knop.addEventListener('click', function () {
      var open = knop.getAttribute('aria-expanded') === 'true';
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
      staart.hidden = open;
      knop.textContent = open ? 'Read more' : 'Read less';
    });
    wrap.appendChild(knop);
    wrap.dataset.salveriGevouwen = '1';
  }

  /* Motion bouwt de collectiesectie opnieuw op bij filteren, sorteren en bij het
     laden van een volgende pagina. Dan staat de onbewerkte tekst er weer en is de
     knop weg. Deze observer klapt hem dan opnieuw in. */
  function houdGevouwen() {
    var sectie = document.querySelector('.collection-description');
    sectie = sectie && sectie.closest('.shopify-section');
    if (!sectie || sectie.dataset.salveriBewaakt === '1') return;
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(function () { vouwBeschrijving(); })
      .observe(sectie, { childList: true, subtree: true });
    sectie.dataset.salveriBewaakt = '1';
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
